import { DownloadOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import List from 'antd/lib/list';
import { useState } from 'react';
import { isEmpty } from 'underscore';
import useGetSampleDataMutation from '../../../queries/useGetSampleDataMutation';
import { downloadFile } from '../../../utils/downloadFile';
import styles from './Metadata.module.scss';

export default function MetadataList(props: {
  data: { [key: string]: any };
  datasetAcronym: string;
  isOfflineDataset: boolean;
}) {
  const [modalState, setModalState] = useState({ visible: false, image: '' });

  const showModal = (imgSrc: string) => {
    setModalState({ visible: true, image: imgSrc });
  };

  const handleCancel = () => {
    setModalState({ visible: false, image: '' });
  };

  const { mutate: getSampleData, isPending: isDownloading } =
    useGetSampleDataMutation({
      onSuccess: (link: string) => {
        downloadFile(link);
      },
    });

  const renderMetadataItem = (key: string) => {
    switch (key) {
      case 'Illustration (Image)': {
        const { name, link_img } = props.data[key];
        return (
          <List.Item className={styles.row}>
            <div className={styles.rowTitle}>{key}</div>
            <div className={styles.rowDetail}>
              <div>{name}</div>
              <img
                style={{ maxWidth: 170, cursor: 'pointer' }}
                src={link_img}
                alt={key}
                onClick={() => showModal(link_img)}
              />
            </div>
          </List.Item>
        );
      }
      case 'Geographical Range':
      case 'Temporal Range': {
        const list = props.data[key] as string[];
        const displayValue = list.join('\n');

        return (
          <List.Item className={styles.row}>
            <div className={styles.rowTitle}>{key}</div>
            <div
              className={`${styles.rowDetail} ${styles.geographicalCoverage}`}
            >
              {isEmpty(list) ? '--' : displayValue}
            </div>
          </List.Item>
        );
      }
      case 'Geographical Coverage': {
        const data = props.data[key];
        const displayValue = Array.isArray(data) ? data.join('\n') : data;

        return (
          <List.Item className={styles.row}>
            <div className={styles.rowTitle}>{key}</div>
            <div
              className={`${styles.rowDetail} ${styles.geographicalCoverage}`}
            >
              {isEmpty(data) ? '--' : displayValue}
            </div>
          </List.Item>
        );
      }
      case 'Name (Unit)': {
        const list = (props.data[key].values || []) as string[];
        return (
          <List.Item className={styles.row}>
            <div className={styles.rowTitle}>{key}</div>
            <div className={styles.rowDetail}>
              {list.map((content, index) => {
                return <div key={index}>{content}</div>;
              })}
            </div>
          </List.Item>
        );
      }
      case 'References (Links)': {
        const isArray = Array.isArray(props.data[key]);
        const empty = isEmpty(props.data[key]);
        const links = isArray
          ? props.data[key]
          : empty
          ? []
          : props.data[key].link
          ? [
              {
                name: props.data[key].name ? props.data[key].name : 'Reference',
                link: props.data[key].link,
              },
            ]
          : [];

        return (
          <List.Item className={styles.row}>
            <div className={styles.rowTitle}>{key}</div>
            <div className={styles.rowDetail}>
              {links.map((link: any, index: number) => {
                return (
                  link &&
                  link.link && (
                    <div key={index} className={styles.row}>
                      <div
                        className={styles.link}
                        onClick={() => {
                          window.open(link.link);
                        }}
                      >
                        {link.name}
                      </div>
                    </div>
                  )
                );
              })}
            </div>
          </List.Item>
        );
      }
      case 'Sample Data (.csv)': {
        return (
          props.data?.[key] && (
            <List.Item className={styles.row}>
              <div className={styles.rowTitle}>{'Sample Data (.zip)'}</div>
              <div className={styles.rowDetail}>
                {!props.isOfflineDataset ? (
                  <Button
                    type='primary'
                    icon={<DownloadOutlined />}
                    size='small'
                    loading={isDownloading}
                    onClick={() => {
                      getSampleData({ datasetAcronym: props.datasetAcronym });
                    }}
                  >
                    Download
                  </Button>
                ) : (
                  '--'
                )}
              </div>
            </List.Item>
          )
        );
      }
      default:
        return (
          <List.Item className={styles.row}>
            <div className={styles.rowTitle}>{key}</div>
            <div className={styles.rowDetail}>
              {isEmpty(props.data[key]) ? '--' : props.data[key]}
            </div>
          </List.Item>
        );
    }
  };

  return (
    <>
      <List
        className={styles.metadataList}
        size='small'
        bordered
        dataSource={Object.keys(props.data)}
        renderItem={renderMetadataItem}
      />
      <Modal
        open={modalState.visible}
        footer={null}
        onCancel={handleCancel}
        style={{
          minWidth: '850px',
          minHeight: '850px',
          maxWidth: '1000px',
          maxHeight: '1000px',
        }}
        zIndex={99999}
      >
        <img
          src={modalState.image}
          alt='Full Screen'
          style={{
            width: '100%',
            height: '100%',
          }}
        />
      </Modal>
    </>
  );
}
